<template>
  <div class="store-skeleton">
    <skeleton
        type="rect"
        :width="'100%'"
        :height="'200px'"
        :circle='false'
      />
      <!-- <section class="selected-store-info">
        <div class="container">
          <div class="columns mb0 is-mobile selected-store-info--header">
            <div class="column is-12-mobile is-12-tablet store-info">
              <div class="store-detail mb0">
                <div><skeleton type="rect" :width="'150px'" :height="'25px'"/></div>
                <div><skeleton type="rect" :width="'300px'" :height="'25px'"/></div>
                <div><skeleton type="rect" :width="'200px'" :height="'25px'"/></div>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <skeleton
        type="rect"
        :width="'100%'"
        :height="'50px'"
      />
      <skeleton-filter-with-item/>
  </div>
</template>

<script>

import SkeletonFilterWithItem from './SkeletonFilterWithItem.vue';
export default {
  name: "StoreProfileSkeleton",
  components: {
    SkeletonFilterWithItem,
  },

}
</script>
<style scoped>
.store-skeleton {
    position: relative;
    top: -5px;
}
</style>